export default "__VITE_ASSET__dc60315c__"